<template>
    <div id="main">
        <loader v-if="isLoading"/>
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs"/>

            <div class="novo-un-medida">
                <!-- TÍTULO -->
                <h1 class="title">{{ $t('unidade-medida') }}{{ unidadeMedida.id != null ?  `: ${unidadeMedida.descricao}` : `: ${$t('nova-unidade-medida')}` }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li><a class="a-inativo">{{$t('vendas')}}</a></li>
                        <li><a class="a-inativo">{{$t('cadastros')}}</a></li>
                        <li><a @click="$router.push({ name: 'venda-unidades-medida' })">{{$t('unidades-medida')}}</a></li>
                        <li><a aria-current="page">{{ unidadeMedida.id!=null ? unidadeMedida.descricao : $t('nova-unidade-medida') }}</a></li>
                    </ul>
                </nav>

                <!-- FORMULÁRIO -->
                <div class="form-columns-fit mt-5">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input 
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="unidadeMedida.idunidademedidaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!unidadeMedida.idunidademedidaerp"
                                tooltipLabel="cod-ref"
                                :disabled="unidademedidaIntegracao"
                            />
                        </div>
                        <!-- DESCRIÇÃO -->
                        <div class="column is-7">
                            <v-input 
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="unidadeMedida.descricao"
                                :placeholder="'descricao-un-medida-placeholder'"
                                :maxlength="50"
                                :title="'descricao-un-medida'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!unidadeMedida.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                                :disabled="unidademedidaIntegracao"
                            />
                        </div>
                        <!-- SITUAÇÃO -->
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect" 
                                :options="situacoes" 
                                v-model="unidadeMedida.situacao" 
                                :mlLabels="true"
                                title="situacao"
                                tooltipLabel="info-situacao-generica"
                                tooltipPosition="is-left"
                                :disabled="unidademedidaIntegracao"
                            />
                        </div>
                    </div>
                </div>

                <!-- BOTÕES -->
                <div class="form-buttons">
                    <button class="delete-btn" type="button" @click="$router.push({name: 'venda-unidades-medida'})">
                        {{ $t('voltar') }}
                    </button>
                    <button v-if="(allowedUpdateUnidade || allowedCreateUnidade)&&!unidademedidaIntegracao" class="save-btn" type="button" @click="saveUnMedida" :disabled="isSaving">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterBar from "@/components/shared/Filter";
import UnidadeMedidaService from "@/services/UnidadeMedidaService";
import UnidadeMedidaValidation from "@/services/validations/UnidadeMedidaValidation";
import Message from "@/models/Message";

export default {
    data() {
        return {
            unidademedidaIntegracao: this.$store.state.user.tabelasERPWebServer.includes("UNIDADEMEDIDA"),
            isLoading: false,
            unidadeMedida: {
                id: null,
                idunidademedidaerp: null,
                descricao: null,
                situacao: null
            },
            service: null,
            msgs: [],
            isSaving: false,
            situacoes: [{ label: "inativo", id: 0 }, { label: "ativo", id: 1 }],
            validation: null,
            permissao: {},
            isUpdate: false,
        };
    },
    computed: {
        allowedUpdateUnidade() {
            return this.isUpdate
                && this.permissao.update;
        },
        allowedCreateUnidade() {
            return !this.isUpdate
                && this.permissao.create;
        },
    },
    created() {
        this.isUpdate = this.$route.params.id != null
            && this.$route.params.id != 'new';
        
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'venda-unidades-medida');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'unidade-medida' },
        });
        
        (!this.isUpdate && !this.allowedCreateUnidade) && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'unidade-medida' },
        });

        this.service = new UnidadeMedidaService(this.$http, this.$router);
        this.validation = new UnidadeMedidaValidation(this.msgs);

        if (this.$route.params.id && this.$route.params.id!='new') {
            this.carregarDados(this.$route.params.id);
        } else {
            this.unidadeMedida.situacao = this.situacoes[1];
        }
    },
    components: {
        FilterBar,
    },
    methods: {
        carregarDados (id) {
            this.isLoading = true;

            this.service.find(id)
                .then(body => {
                    if (body.content != null) {
                        this.unidadeMedida.id = body.content.idunidademedida;
                        this.unidadeMedida.descricao = body.content.descricao;
                        this.unidadeMedida.idunidademedidaerp = body.content.idunidademedidaerp;

                        if (body.content.situacao in [0, 1]) {
                            this.unidadeMedida.situacao = this.situacoes[body.content.situacao];
                        } else {
                            console.warn(`ID de situação inválido ao carregar unidade de medida: ${body.content.situacao}`);
                            this.unidadeMedida.situacao = this.situacoes[1];
                        }
                    }
                })
                .catch(e => {
                    console.error(e);

                    this.msgs.push(
                        new Message("error", 'msg-erro-load-un-medida', true)
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        saveUnMedida () {
            this.unidadeMedida = this.mapTosave(this.unidadeMedida);

            if (this.validation.validate(this.unidadeMedida, this.$refs)) {
                this.isSaving = true;
                this.service.save(this.mapOnSave(this.unidadeMedida))
                    .then(body => {
                        if (body.content) {
                            let msg = 'msg-save-un-medida-sucesso';

                            if (this.unidadeMedida.id != null) {
                                msg = 'msg-edit-un-medida-sucesso';
                            }

                            this.msgs.push(new Message("success", msg, true));
                            this.redirectToList(2);
                        } else {
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.unidadeMedida.idunidademedidaerp }),
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch(e => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    new Message(
                                        'alert', 
                                        this.$t(message, { n: this.unidadeMedida.idunidademedidaerp }), 
                                        true, 
                                        false
                                    ));
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally(_ => {
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(
                    new Message("alert", "msg-campos-obrigatorios", true)
                );
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: "venda-unidades-medida"
                });
            }, time * 1000 + 50);
        },
        mapOnSave (um) {
            return {
                idunidademedida: um.id,
                idunidademedidaerp: um.idunidademedidaerp,
                descricao: um.descricao,
                situacao: um.situacao.id
            }
        },
        generateId(numberId){
        return this.$route.name+'-'+numberId;
        },
    }
};
</script>

<style lang="scss" scoped>
$padding: 5px;

#main {
    padding: 0 20px;
    height: auto;
    .page {
        position: relative;
        margin-bottom: 20px;

        .novo-un-medida {
            position: relative;
            width: 100%;
            margin-bottom: 20px;
            padding-top: 0;

            > h1 {
                padding-top: 20px;
                margin-bottom: 40px;
            }

            .form-buttons {
                right: 0;
            }
        }
    }
}

</style>
